import React from "react";
import { motion } from "framer-motion";

const RaindropMotionBouncePop = ({ delay = 0, children }) => {
  return (
    <motion.div
      initial={{
        opacity: 0,
        translateY: 20,
        scale: 0,
      }}
      animate={{
        opacity: 1,
        translateY: 0,
        scale: 1,
        transition: {
          duration: 1.2,
          type: "spring",
          stiffness: 400,
          damping: 20,
          delay: delay,
        },
      }}
      className="flex flex-row items-center gap-2 "
    >
      {children}
    </motion.div>
  );
};

export default RaindropMotionBouncePop;
